module.exports = __webpack_public_path__ + "images/native-access-2x-PJO_MeC.png";